import './Placeholder.css';

export default function Search() {
  return (
    <div className="placeholder-page">
      <div className="placeholder-content">
        <div className="placeholder-icon">🔍</div>
        <h1>Search</h1>
        <p>Global search functionality coming soon</p>
        <p className="placeholder-description">
          Search across all documents and reports to quickly find relevant information
        </p>
      </div>
    </div>
  );
}
